import React, { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import classnames from 'classnames';
import { format } from 'date-fns';
import { Icon, IconSize } from '@/components/common/Icon';
import { Tags } from '@/components/common/Tags';
import { READABLE_DATE_FORMAT } from '@/constants';
import { AssetDecisionItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';
import styles from './DecisionItem.module.scss';

interface DecisionsItemProps {
  decision: AssetDecisionItem;
  tagColorSchema?: Record<string, React.CSSProperties>;
}

export const DecisionItem: React.FC<DecisionsItemProps> = ({ decision, tagColorSchema }) => {
  const t = useTranslations('incidents_page.assets_card');
  const decisionDate = useMemo(() => {
    if (decision.DecisionDateTime) {
      return format(new Date(decision.DecisionDateTime.value), READABLE_DATE_FORMAT);
    }
    return null;
  }, [decision.DecisionDateTime]);

  return (
    <div className={classnames(styles.root, 'w-full')}>
      <div className={styles.title}>{decision.Title}</div>
      <div className={classnames(styles.details, 'flex flex-col gap-[8px]')}>
        <div className={styles.type}>
          <div className={styles.severity}>
            <span className="font-bold">{t('severity')}: </span>
            <span>{decision.DecisionSeverityName}</span>
          </div>
          <div className={styles.decisionType}>
            <span className="font-bold">{t('decision_type')}: </span>
            <span>{decision.DecisionTypeName}</span>
          </div>
        </div>
        <div className={styles.description}>{decision.DecisionDescription}</div>
        <div className={styles.time}>
          <Icon name="CalendarIcon" size={IconSize.s12} />
          <span>{decisionDate}</span>
        </div>
        <div className={styles.tags}>
          <Tags tags={decision.Tags} getTagStyle={(tag) => tagColorSchema?.[tag]} />
        </div>
      </div>
    </div>
  );
};
